(ns ui.components.tab-strip.view
  (:require
   [ui.util :as uu]))

(defn view
  [{:keys [tabs selected-tab default-tab on-change!]}]
  (let [selected-tab (or selected-tab default-tab)]
    (->> tabs
         (map (fn [{:keys [value label disabled?] :as _tab}]
                [:li
                 {:class    (uu/cm "pb-3 *:flex *:gap-2 items-center text-base-light-text font-semibold cursor-pointer"
                                   (when (= value selected-tab) "text-base-light-text-accent border-b border-solid  border-base-light-border-accent ")
                                   (when disabled? "text-disabled-regular-text pointer-events-none"))
                  :on-click #(on-change! value)
                  :disabled disabled?}
                 label]))
         (into
          [:ul
           {:class "flex gap-6 border-b border-solid border-base-light-border-paler"}]))))
